
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCustomerFactsheet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"customerFactsheet"},"name":{"kind":"Name","value":"getCustomerFactsheet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customer_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerDetails"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerAddressFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pan_no"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formation_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"proposed_loans"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"end_use"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"percent_security"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"company_background"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promoters_background"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"project_background"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ecosystem_brief"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"remarks"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"management_persons"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerManagementPersonFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"present_banking_arrangements"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerPbaFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"outstanding_amounts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bg_lc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cc"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"roi"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"asset_classification"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"securities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerSecurityFields"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1077}};
    doc.loc.source = {"body":"#import \"../fragments/CustomerFragment.graphql\"\n#import \"../fragments/CustomerAddressFragment.graphql\"\n#import \"../fragments/CustomerManagementPersonFragment.graphql\"\n#import \"../fragments/CustomerPbaFragment.graphql\"\n#import \"../fragments/CustomerSecurityFragment.graphql\"\n\nquery getCustomerFactsheet($customer_id: Int!) {\n  customerFactsheet: getCustomerFactsheet(customer_id: $customer_id) {\n    ...CustomerDetails\n    addresses {\n      ...CustomerAddressFields\n    }\n    details {\n      id\n      pan_no\n      formation_date\n      proposed_loans {\n        product_type\n        end_use\n        percent_security\n      }\n      company_background\n      promoters_background\n      project_background\n      ecosystem_brief\n      remarks\n    }\n    management_persons {\n      ...CustomerManagementPersonFields\n    }\n    present_banking_arrangements {\n      ...CustomerPbaFields\n      outstanding_amounts {\n        id\n        date\n        bg_lc\n        tl\n        cc\n        roi\n        asset_classification\n      }\n    }\n    securities {\n      ...CustomerSecurityFields\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/CustomerFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/CustomerAddressFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/CustomerManagementPersonFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/CustomerPbaFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/CustomerSecurityFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getCustomerFactsheet"] = oneQuery(doc, "getCustomerFactsheet");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/queries/getCustomerFactsheetQuery.graphql
// module id = 1371
// module chunks = 0